import React, { useEffect, useState } from "react";

import SendIcon from "@mui/icons-material/Send";
import { IconButton, Typography } from "@mui/material";

type Props = {
  handleAskQuestion: () => void;
  processingQuestion: boolean;
  question: string;
  showGeneratingIndicator?: boolean;
};

export const AskButton = ({
  handleAskQuestion,
  processingQuestion,
  question,
  showGeneratingIndicator = true,
}: Props) => {
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    if (processingQuestion && showGeneratingIndicator) {
      const interval = setInterval(() => {
        setDotCount((prevDotCount) => (prevDotCount % 3) + 1);
      }, 500); // Change dots every 500ms
      return () => {
        clearInterval(interval);
      };
    } else {
      setDotCount(1);
    }
  }, [processingQuestion, showGeneratingIndicator]);

  const generateDots = () => ".".repeat(dotCount);

  return (
    <IconButton
      onClick={handleAskQuestion}
      disabled={!question.trim() || processingQuestion}
      sx={{
        justifyContent: processingQuestion && showGeneratingIndicator ? "start" : "center",
      }}
      size="medium"
      color="primary"
      data-cy="ask-button"
    >
      {processingQuestion ? (
        showGeneratingIndicator ? (
          <Typography variant="body2">{`Generating${generateDots()}`}</Typography>
        ) : null
      ) : (
        <SendIcon fontSize="small" />
      )}
    </IconButton>
  );
};
